import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["__distributeEvenly", "Inner", "End", "endSlot", "Middle", "middleSlot", "responsive", "role", "Start", "startSlot"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BASE_SPACING_X } from 'HubStyleTokens/sizes';
import { isIE11 } from '../utils/BrowserTest';

/** @internal */

/** @internal */

/**
 * @internal
 * Ask about your use case in #hds-support.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Toolbar = styled.div.withConfig({
  displayName: "AbstractToolbar__Toolbar",
  componentId: "sc-1ywksa0-0"
})(["padding:", " 0 0 ", ";"], BASE_SPACING_X, BASE_SPACING_X);
const ToolbarInner = styled.div.withConfig({
  displayName: "AbstractToolbar__ToolbarInner",
  componentId: "sc-1ywksa0-1"
})(["align-items:center;display:flex;flex-wrap:", ";justify-content:", ";margin:-", " 0 0 -", ";> * + *{margin-left:", ";}"], props => props.responsive && 'wrap', ({
  $justifyEnd
}) => $justifyEnd ? 'flex-end' : 'space-between', BASE_SPACING_X, BASE_SPACING_X, BASE_SPACING_X);
const SlotFlexContainer = styled.div.withConfig({
  displayName: "AbstractToolbar__SlotFlexContainer",
  componentId: "sc-1ywksa0-2"
})(["align-items:center;display:flex;flex-shrink:0;flex:", ";> * + *{margin-left:", ";}> .private-button.private-button{flex-shrink:0;margin-top:0;width:auto;}"], props => props.__distributeEvenly && !isIE11() && '1 1 0%', BASE_SPACING_X);
const StartSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__StartSlot",
  componentId: "sc-1ywksa0-3"
})(["justify-content:flex-start;"]);
const MiddleSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__MiddleSlot",
  componentId: "sc-1ywksa0-4"
})(["flex-grow:0;flex-shrink:1;justify-content:center;white-space:", ";"], props => props.__distributeEvenly && 'nowrap');
const EndSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__EndSlot",
  componentId: "sc-1ywksa0-5"
})(["justify-content:flex-end;"]);
const AbstractToolbar = props => {
  const {
      __distributeEvenly,
      Inner,
      End,
      endSlot,
      Middle,
      middleSlot,
      responsive,
      role,
      Start,
      startSlot
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Toolbar, Object.assign({}, rest, {
    role: role,
    children: /*#__PURE__*/_jsxs(Inner, {
      responsive: responsive,
      $justifyEnd: !!endSlot && !startSlot && !middleSlot,
      children: [startSlot ? /*#__PURE__*/_jsx(Start, {
        __distributeEvenly: __distributeEvenly,
        children: startSlot
      }) : null, middleSlot ? /*#__PURE__*/_jsx(Middle, {
        __distributeEvenly: __distributeEvenly,
        children: middleSlot
      }) : null, endSlot ? /*#__PURE__*/_jsx(End, {
        __distributeEvenly: __distributeEvenly,
        children: endSlot
      }) : null]
    })
  }));
};
AbstractToolbar.propTypes = {
  __distributeEvenly: PropTypes.bool,
  End: PropTypes.elementType,
  endSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  Inner: PropTypes.elementType,
  Middle: PropTypes.elementType,
  middleSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  responsive: PropTypes.bool.isRequired,
  role: PropTypes.string,
  Start: PropTypes.elementType,
  startSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  flush: PropTypes.bool
};
AbstractToolbar.defaultProps = {
  End: EndSlot,
  Inner: ToolbarInner,
  Middle: MiddleSlot,
  responsive: true,
  role: 'group',
  Start: StartSlot
};
AbstractToolbar.displayName = 'AbstractToolbar';
export default AbstractToolbar;